import React, {Component} from 'react';

import styles from "../DatiSpecifici.module.css"
import {withTranslation} from "react-i18next";
import Calendar from "../../../../../components/calendar/Calendar";
import Utils from "../../../../../utils/Utils";
import Button from "../../../../../components/button/Button";
import Icon from "../../../../../components/icon/Icon";
import OggettiUtili from "../../../../../utils/OggettiUtili"
import Select from "../../../../../components/select/Select"
import icd9 from "../../../../../utils/ICD9-diagnosi.json"
import Autocomplete from "../../../../../components/autocomplete/Autocomplete";


const tipoSequeleMap = OggettiUtili.tipoSequele;
const patologie = icd9.diagnosi;
const nonNote2 = "00000*";
const nonNote = "00000";
const nessuna = "00001"
patologie.push(
    {
        "codice": "00000",
        "descrizione": "NON NOTE/I"
    },
    {
        "codice": "00001",
        "descrizione": "NESSUNA/O"
    }
)
const patologie_icd9 = patologie.sort(Utils.SorterObjectDesc)


class EventiCorrelabili extends Component {

    state = {

        eventiCorrelabili: {
            listaEventiCorrelabili: [],
            corretto: []
        },
        clicksSequela: 0,
        boxesSequela: [],
        listaInfoPatologie: [],
        listaInfoTipo: [],
        patologia: "",
        tipo: "",
        data: ""

    }

    constructor(props) {
        super(props);

        this.riceviValore = this.riceviValore.bind(this);
        this.handleChangePatologia = this.handleChangePatologia.bind(this);
        this.handleChangeTipo = this.handleChangeTipo.bind(this);
        this.handleClickSequela = this.handleClickSequela.bind(this);
        this.aggiungiElemento = this.aggiungiElemento.bind(this);
        this.controlloData = this.controlloData.bind(this);
        this.validate = this.validate.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.uniqueObjectEventiCorrelabili = this.uniqueObjectEventiCorrelabili.bind(this)
        this.eliminaRow = this.eliminaRow.bind(this)
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.eventiCorrelabili) {
            let propsEventi = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.eventiCorrelabili))
            let stateEventi = this.state.eventiCorrelabili
            stateEventi.listaEventiCorrelabili = propsEventi.listaEventiCorrelabili ? propsEventi.listaEventiCorrelabili : this.state.eventiCorrelabili.listaEventiCorrelabili
            if (stateEventi.listaEventiCorrelabili) {
                for (let i = 0; i < stateEventi.listaEventiCorrelabili.length; i++) {
                    this.handleClickSequela()
                    this.state.clicksSequela++
                }
                this.controlloData()
            } else {
                this.handleClickSequela()
                this.controlloData()
            }
        } else {
            if (this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)) {
                this.primoAggiungiElemento();
            }
            this.handleClickSequela()
            this.controlloData()
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clicksSequela > this.state.clicksSequela) {
            this.handleClickSequela()
        }
        if (prevState !== this.state) {
            let objFinal = this.createJsonForBackend()
            this.props.setEventiCorrelabili(this.state.eventiCorrelabili, this, objFinal);
        }
    }

    createJsonForBackend(stateEventi) {

        let eventiCorrelabili = JSON.parse(JSON.stringify(stateEventi ? stateEventi : this.state.eventiCorrelabili));
        let eventiCorrelabiliPulito = {}
        let listaEventiCorrelabiliPulita = []
        let arrayEventiCorrelabiliPulito = []

        for (let i = 0; i < eventiCorrelabili.listaEventiCorrelabili.length; i++) {
            arrayEventiCorrelabiliPulito = []
            let eventiCorrelabiliSingolo = Utils.removeEmptyValueFromObject(eventiCorrelabili.listaEventiCorrelabili[i])

            if (arrayEventiCorrelabiliPulito.length > 0) {
                eventiCorrelabiliSingolo["listaEventiCorrelabili"] = arrayEventiCorrelabiliPulito
            } else {
                Utils.removeFieldFromObject(eventiCorrelabiliSingolo, "listaEventiCorrelabili")
            }
            if (!Utils.isEmpty(eventiCorrelabiliSingolo)) {
                listaEventiCorrelabiliPulita.push(eventiCorrelabiliSingolo)
            }
        }
        if (listaEventiCorrelabiliPulita.length > 0) {
            eventiCorrelabiliPulito["listaEventiCorrelabili"] = listaEventiCorrelabiliPulita
        }
        let objFinal = Utils.removeEmptyValueFromObject(eventiCorrelabiliPulito)
        return objFinal
    }

    uniqueObjectEventiCorrelabili(elEventiCorrelabili) {
        const tmpeventiCorrelabili = new Map()
        let eventiCorrelabili = JSON.parse(JSON.stringify(this.state.eventiCorrelabili))

        const rsEventiCorrelabili = elEventiCorrelabili.reduce((acc, e) => {
            if (tmpeventiCorrelabili.has(e.tipo) && tmpeventiCorrelabili.has(e.dataInizio) && tmpeventiCorrelabili.has(e.patologia)) {
                if (!tmpeventiCorrelabili.get(e.tipo).includes(e.jobid) && !tmpeventiCorrelabili.get(e.dataInizio).includes(e.jobid) && !tmpeventiCorrelabili.get(e.patologia).includes(e.jobid)) {
                    acc.push(e)
                    tmpeventiCorrelabili.set(e.tipo, [...tmpeventiCorrelabili.get(e.tipo), e.jobid])
                    tmpeventiCorrelabili.set(e.dataInizio, [...tmpeventiCorrelabili.get(e.dataInizio), e.jobid])
                    tmpeventiCorrelabili.set(e.patologia, [...tmpeventiCorrelabili.get(e.patologia), e.jobid])
                }
            } else {
                acc.push(e)
                tmpeventiCorrelabili.set(e.tipo, [e.jobid])
                tmpeventiCorrelabili.set(e.dataInizio, [e.jobid])
                tmpeventiCorrelabili.set(e.patologia, [e.jobid])
            }
            return acc
        }, [])

        eventiCorrelabili.listaEventiCorrelabili = rsEventiCorrelabili
        return eventiCorrelabili
    }

    validate() {
        for (let i = 0; i < this.state.eventiCorrelabili.listaEventiCorrelabili.length; i++) {
            let validateDataInizio = Utils.checkDateInterval(this.state.eventiCorrelabili.listaEventiCorrelabili[i].dataInizio, "31/12/1899");
            let checkTodayDataInizio = Utils.checkDateLowerToday(this.state.eventiCorrelabili.listaEventiCorrelabili[i].dataInizio);
            if (validateDataInizio) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AC"]), 1
                )
            } else if (checkTodayDataInizio) {
                return (
                    this.props.aggiungiToaster(
                        ["Messages.ERR_01_01_0F_AD"]), 1
                )

            }
        }


        let eventi = JSON.parse(JSON.stringify(this.state.eventiCorrelabili.listaEventiCorrelabili))
        let arrayeventiPulito = Utils.removeEmptyValueFromObject(eventi)
        let arrayNuovoeventi = Utils.eliminaNullArray(arrayeventiPulito)

        let objFinal = this.createJsonForBackend(this.uniqueObjectEventiCorrelabili(arrayNuovoeventi))
        this.props.setEventiCorrelabili(this.state.eventiCorrelabili, this, objFinal);

    }

    controlloData() {

        let eventi = this.state.eventiCorrelabili;
        eventi.corretto = []
        let controlloDati = {patologia: false, tipo: false, dataInizio: false}
        for (let i = 0; i < eventi.listaEventiCorrelabili.length; i++) {

            if (eventi.listaEventiCorrelabili[i].patologia && eventi.listaEventiCorrelabili[i].patologia.codice && (eventi.listaEventiCorrelabili[i].patologia.codice === nessuna || eventi.listaEventiCorrelabili[i].patologia.codice === nonNote || eventi.listaEventiCorrelabili[i].patologia.codice === nonNote2) && eventi.listaEventiCorrelabili.length > 1) {
                eventi.corretto[0] = "Campo \"Patologia\" da modificare inserendo un valore valido (diverso da \"NON NOTE/I\" oppure \"NESSUNA/O\") oppure eliminare la Patologia"
                controlloDati.patologia = true
            }
        }

        if(controlloDati.patologia === false) {
            for (let i = 0; i < eventi.listaEventiCorrelabili.length; i++) {
                if (!eventi.listaEventiCorrelabili[i].patologia && !controlloDati.patologia) {
                    eventi.corretto[0] = "Campo \"Patologia\" mancante"
                    controlloDati.patologia = true
                }

                if (!eventi.listaEventiCorrelabili[i].tipo && eventi.listaEventiCorrelabili[i].patologia && eventi.listaEventiCorrelabili[i].patologia.codice && eventi.listaEventiCorrelabili[i].patologia.codice !== nessuna && eventi.listaEventiCorrelabili[i].patologia.codice !== nonNote && eventi.listaEventiCorrelabili[i].patologia.codice !== nonNote2 && !controlloDati.tipo) {
                    eventi.corretto[1] = "Campo \"Tipo\" mancante"
                    controlloDati.tipo = true
                }

                if (eventi.listaEventiCorrelabili[i].patologia && eventi.listaEventiCorrelabili[i].patologia.codice && (eventi.listaEventiCorrelabili[i].patologia.codice !== nessuna && eventi.listaEventiCorrelabili[i].patologia.codice !== nonNote && eventi.listaEventiCorrelabili[i].patologia.codice !== nonNote2) && eventi.listaEventiCorrelabili[i].dataInizio && Utils.isDateInValid(Utils.transformDateForBackend(eventi.listaEventiCorrelabili[i].dataInizio), "-") && !controlloDati.dataInizio) {
                    eventi.corretto[2] = "Campo \"Data di inizio\" errata"
                    controlloDati.dataInizio = true
                }
                if (eventi.listaEventiCorrelabili[i].patologia && eventi.listaEventiCorrelabili[i].patologia.codice && (eventi.listaEventiCorrelabili[i].patologia.codice !== nessuna && eventi.listaEventiCorrelabili[i].patologia.codice !== nonNote && eventi.listaEventiCorrelabili[i].patologia.codice !== nonNote2 && (eventi.listaEventiCorrelabili[i].tipo === "500" || eventi.listaEventiCorrelabili[i].tipo === "501"))) {
                    eventi.corretto[3] = "Campo \"Tipo\" errato"
                    controlloDati.tipo = true
                }
            }
        }

        this.setState({eventiCorrelabili: eventi})
    }

    riceviValore(field) {

        let data = this.state.eventiCorrelabili
        let click = this.state.clicksSequela - 1

        if (field.currentTarget.id.includes("dataInizio")) {
            let indice = field.currentTarget.id.replace("dataInizio", "")
            data.listaEventiCorrelabili[indice].dataInizio = field.target.value
        }

        this.setState({eventiCorrelabili: data, clicksSequela: click});
        this.controlloData();
    }

    handleChangePatologia(field, event) {

        let patologieNew = this.state.eventiCorrelabili
        let click = this.state.clicksSequela - 1

        patologieNew.listaEventiCorrelabili[field].patologia = event.target.value
        patologieNew.listaEventiCorrelabili[field].dataInizio = ""
        patologieNew.listaEventiCorrelabili[field].tipo = ""

        this.setState({eventiCorrelabili: patologieNew, clicksSequela: click});
        this.controlloData();
    }

    handleChangeTipo(event) {

        let tipoNew = this.state.eventiCorrelabili
        let click = this.state.clicksSequela - 1

        tipoNew.listaEventiCorrelabili[event.target.id].tipo = event.target.value

        this.setState({eventiCorrelabili: tipoNew, clicksSequela: click});
        this.controlloData();

    }

    aggiungiElemento() {
        let eventiCorrelabiliCopia = this.state.eventiCorrelabili;

        eventiCorrelabiliCopia.listaEventiCorrelabili.push({
            patologia: "",
            tipo: "",
            dataInizio: ""
        })

        this.setState({eventiCorrelabili: eventiCorrelabiliCopia})
        this.controlloData();
    }

    primoAggiungiElemento() {
        let eventiCorrelabiliCopia = this.state.eventiCorrelabili;

        eventiCorrelabiliCopia.listaEventiCorrelabili.push({
            patologia: { codice: "00000*", descrizione: "NON NOTE/I" },
            tipo: "",
            dataInizio: ""
        })

        this.setState({eventiCorrelabili: eventiCorrelabiliCopia})
        this.controlloData();
    }

    eliminaRow(i) {
        let eventiCorrelabili = this.state.eventiCorrelabili;
        let boxesSequela = this.state.boxesSequela
        let clicksSequela = this.state.clicksSequela
        eventiCorrelabili.listaEventiCorrelabili.splice(i, 1)
        boxesSequela.splice(i, 1)
        this.setState({boxesSequela: boxesSequela, eventiCorrelabili: eventiCorrelabili});
        if (i === 1) clicksSequela = clicksSequela - 1
        else clicksSequela = clicksSequela - 2
        this.handleClickSequela(clicksSequela)
    }

    handleClickSequela(clicksSequela) {

        let clicks = clicksSequela ? clicksSequela : this.state.clicksSequela === this.state.eventiCorrelabili.listaEventiCorrelabili.length ? this.state.clicksSequela : this.state.clicksSequela + 1
        let boxesSequela = [];

        for (let i = 0; i < clicks; i++)
            boxesSequela.push(
                <div>
                    <div className="row">
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello4' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.EventiCorrelabili.patologia")}
                                <span className={styles.mandatoryColor}>*</span></p>

                            <Autocomplete id={i}
                                          value={this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia}
                                          keyField={"codice"}
                                          descriptionField={"descrizione"}
                                          suggestionField={"descrizione"}
                                          onChange={this.handleChangePatologia}
                                          field={i}
                                          placeholder={"Patologie"}
                                          suggestions={patologie_icd9}
                                          addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === "00000*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                            >
                            </Autocomplete>
                        </div>


                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.EventiCorrelabili.tipo")}
                                {(this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice !== nessuna && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice !== nonNote && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice !== nonNote2) &&
                                    <span className={styles.mandatoryColor}>*</span>
                                }
                            </p>
                            <Select
                                value={this.state.eventiCorrelabili.listaEventiCorrelabili[i].tipo}
                                onChange={this.handleChangeTipo}
                                id={i}
                                style={{width: "100%"}}
                                disabled={this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice && (this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nessuna || this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nonNote || this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nonNote2)}
                                functionMap={tipoSequeleMap.map((oggetto) => {
                                    return (<option value={oggetto.code}>{oggetto.displayName}</option>)
                                })}
                            >

                            </Select>

                        </div>


                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{this.props.t("DatiSpecifici.EventiCorrelabili.dataInizio")} </p>
                            <Calendar id={"dataInizio".concat(i)}
                                      onChange={this.riceviValore}
                                      field={"dataInizio".concat(i)}
                                      value={this.state.eventiCorrelabili.listaEventiCorrelabili[i].dataInizio}
                                      disabled={this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice && (this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nessuna || this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nonNote || this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nonNote2)}
                                      errorMessage={"Data non valida"}
                                      placeholder={this.props.t("DatiSpecifici.EventiCorrelabili.dataInizio")}
                                      error={(this.state.eventiCorrelabili.listaEventiCorrelabili[i].dataInizio === "" || this.state.eventiCorrelabili.listaEventiCorrelabili[i].dataInizio == null) ? false :
                                          Utils.isDateInValid(Utils.transformDateForBackend(this.state.eventiCorrelabili.listaEventiCorrelabili[i].dataInizio), "-")
                                      }>
                            </Calendar>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                             style={{marginTop: "-7px"}}>
                            {i < 1 ? <Button
                                className={styles.testo}
                                classes="btn mt-2 btnBluOutline mb-1 "
                                style={{
                                    marginTop: "2.7rem",
                                    padding: "5px",
                                    border: "none",
                                    background: "none",
                                    float: "right"
                                }}
                                text={this.props.t("DatiSpecifici.EventiCorrelabili.sequela")}
                                icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                disabled={this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia && this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice && (this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nessuna || this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nonNote || this.state.eventiCorrelabili.listaEventiCorrelabili[i].patologia.codice === nonNote2)}
                                onClick={() => {
                                    this.aggiungiElemento();
                                    this.handleClickSequela()
                                }}
                            /> : !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                <span id={"elimina" + i}
                                      onClick={() =>
                                          this.eliminaRow(i)

                                      }
                                ><Icon id={"it-delete"} style={{fill: "red", marginTop: "2.8rem", cursor: "pointer"}}/></span>
                                : <div></div>
                            }
                        </div>
                    </div>
                </div>
            )

        this.setState({boxesSequela: boxesSequela, clicksSequela: clicks});
        this.controlloData();

    }

    render() {

        const {t} = this.props;

        return (

            <div style={{marginTop: "1rem"}}>
                <b><p className={styles.titleText}>{t("DatiSpecifici.EventiCorrelabili.titolo")}</p></b>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    {this.state.boxesSequela}
                </div>
            </div>

        );
    }
}

export default withTranslation('common')(EventiCorrelabili);
